const FINANCE_URL = process.env.REACT_APP_PERMISSION_APIS
const BASEURL = process.env.REACT_APP_BACKEND_URL

export const endPoint = {
  // Lease Aggrement
  CREATE_LEASE_AGRE: `${BASEURL}/api/LeaseAgreement/CreateLease`,
  UPDATE_LEASE_AGRE: `${BASEURL}/api/SaleOrder/Update`,
  GET_LEASE_AGRE: `${BASEURL}/api/LeaseAgreement/Get`,
  DELETE_LEASE_AGRE: `${BASEURL}/api/LeaseAgreement/DeleteLease`,
  EDIT_LEASE_AGRE: `${BASEURL}/api/LeaseAgreement/EditLease`,
  RENEW_LEASE_AGRE: `${BASEURL}/api/LeaseAgreement/RenewLease`,
  CREATE_LEASE_ADDITION_AMOUNT_RENEW: `${BASEURL}/api/LeaseAgreement/CreateLeaseAdditionAmountRenew`,
  SAVE_ADDITION_AMOUNT_RENEW_LINES: `${BASEURL}/api/LeaseAgreement/SaveAdditionAmountRenewLines`,
  RENEW_LEASE_BULK: `${BASEURL}/api/LeaseAgreement/RenewLeaseBulk`,
  TERMINATE_LEASE_BULK: `${BASEURL}/api/LeaseTermination/LeaseTerminationBulk`,

  // Lease Proposal
  CREATE_LEASE_PROP: `${BASEURL}/api/LeaseProposal/CreateProposal`,
  DELETE_LEASE_PROP: `${BASEURL}/api/LeaseProposal/DeleteLease`,
  EDIT_LEASE_PROP: `${BASEURL}/api/LeaseProposal/EditProposal`,
  GET_LEASE_PROP: `${BASEURL}/api/LeaseProposal/Get`,
  GET_DROP_PROP: `${BASEURL}/api/LeaseProposal/GetDropDown`,
  GET_DDLS_PROP: `${BASEURL}/api/LeaseProposal/GetProposalCreateDdls`,
  GET_COMMON_PROP: `${BASEURL}/api/LeaseProposal/GetCommonData`,
  // Lease Receipt

  RECEIPT_DROPDOWN: `${BASEURL}/api/LeaseReceipt/GetMultipleDropdown`,
  CASCAD_DROP: `${BASEURL}/api/LeaseReceipt/GetCascadDropdown`,
  LEASE_NO_DATA: `${BASEURL}/api/LeaseReceipt/GetCommonData`,
  CREATE_LEASE_RECEIPT: `${BASEURL}/api/LeaseReceipt/CreateReceipt`,
  GET_RECEIPT: `${BASEURL}/api/LeaseReceipt/Get`,

  // Approval
  GET_LEASE_APPROVAL: `${BASEURL}/api/LeaseApproval/GetApprovalList`,
  POST_LEASE_APPROVAL: `${BASEURL}/api/LeaseApproval/SaveApprovalList`,
  POST_INVOICE_APPROVAL: `${BASEURL}/api/LeaseApproval/SaveInvoiceApprovalList`,
  GET_INVOICE_APPROVAL: `${BASEURL}/api/LeaseApproval/GetInvoiceApprovalList`,
  GET_PROPOSAL_APPROVAL: `${BASEURL}/api/LeaseApproval/GetProposalApprovalList`,
  POST_PROPOSAL_APPROVAL: `${BASEURL}/api/LeaseApproval/SaveProposalApprovalList`,

  // DropDown
  GET_UNITNO_DROP: `${BASEURL}/api/LeaseAgreement/GetDropDown`,
  GET_PROPERT_DROP: `${BASEURL}/api/LeaseAgreement/GetLeaseCreateDdls`,
  GET_UNITNO_DATA: `${BASEURL}/api/LeaseCommon/GetCommonData`,
  GET_CURRENCY_PER: `${FINANCE_URL}/api/finance/currencies/listing`,

  // Single Invoice
  GET_INVOICE_LIST: `${BASEURL}/api/SingleInvoice/GetLeaseInvoices`,
  GET_INVOICE_DROP: `${BASEURL}/api/SingleInvoice/GetLeaseSingleInvoiceDdls`,
  GET_INVOICE_COMMON: `${BASEURL}/api/SingleInvoice/GetSingleInvoiceCommonData`,
  GET_INVOICE_CASCAD: `${BASEURL}/api/SingleInvoice/GetSingleInvoiceCascadDdls`,
  POST_SINGLE_INVOICE: `${BASEURL}/api/SingleInvoice/Create`,
  GET_SINGLE_INVOICE: `${BASEURL}/api/SingleInvoice/Get`,
  POST_CREDIT_NOTE: `${BASEURL}/api/SingleInvoice/IssueCreditNote`,
  // Installment Invoice
  GET_INSTALL_INVOICE_LIST: `${BASEURL}/api/InstallmentInvoice/Get`,
  GET_INSTALL_INVOICE_DROP: `${BASEURL}/api/InstallmentInvoice/GetLeaseInstallmentInvoiceDdls`,
  GET_INSTALL_INVOICE_COMMON: `${BASEURL}/api/InstallmentInvoice/GetInstallmentInvoiceCommonData`,
  GET_INSTALL_INVOICE_CASCAD: `${BASEURL}/api/InstallmentInvoice/GetInstallmentInvoiceCascadDdls`,
  POST_INSTALL_INVOICE: `${BASEURL}/api/InstallmentInvoice/Create`,
  // Lease Proposal
  GET_PROPOSAL_LIST: `${BASEURL}/api/LeaseProposal/Get`,
  CREATE_PROPOSAL: `${BASEURL}/api/LeaseProposal/CreateLease`,
  EDIT_PROPOSAL: `${BASEURL}/api/LeaseProposal/EditLease`,
  DELETE_PROPOSAL: `${BASEURL}/api/LeaseProposal/DeleteLease`,
  GET_PROPOSAL_DROPDOWN: `${BASEURL}/api/LeaseProposal/GetDropDown`,
  GET_PROPOSAL_DLS: `${BASEURL}/api/LeaseProposal/GetLeaseCreateDdls`,
  // Bulk Receipt
  GET_BULK_RECEIPT: `${BASEURL}/api/LeaseBulkReceipt/Get`,
  CREATE_BULK_RECEIPT: `${BASEURL}/api/LeaseBulkReceipt/CreateReceipt`,
  MULTIDROP_BULK_RECEIPT: `${BASEURL}/api/LeaseBulkReceipt/GetMultipleDropdown`,
  CASCAD_BULK_RECEIPT: `${BASEURL}/api/LeaseBulkReceipt/GetCascadDropdown`,
  COMMON_BULK_RECEIPT: `${BASEURL}/api/LeaseBulkReceipt/GetCommonData`,

  //Dashboard stats
  // Dashboard
  GET_DASHBOARD_LIST: `${BASEURL}/api/LeaseDashboard/GetDashboardUnits`,
  GET_DASHBOARD_DROP: `${BASEURL}/api/LeaseDashboard/GetMultipleDropdown`,
  GET_DASHBOARD_CASCAD: `${BASEURL}/api/LeaseDashboard/GetCascadDropdown`,
  GET_DASHBOARD_STATS: `${BASEURL}/api/LeaseDashboard/GetDashboardStats`,

  // Lease Termination
  GET_LEASE_TERMINATION: `${BASEURL}/api/LeaseTermination/Get`,
  POST_LEASE_TERMINATION: `${BASEURL}/api/LeaseTermination/CreateLeaseTermination`,
  TERMINATION_COMMON: `${BASEURL}/api/LeaseTermination/GetCommonData`,
  TERMINATION_MULTI: `${BASEURL}/api/LeaseTermination/GetMultipleDropdown`,
  TERMINATION_CASCAD: `${BASEURL}/api/LeaseTermination/GetCascadDropdown`,

  // Lease Reverse Receipt
  GET_LEASE_REVERSE: `${BASEURL}/api/LeaseReverseReceipt/Get`,
  POST_LEASE_REVERSE: `${BASEURL}/api/LeaseReverseReceipt/CreateReverseReceipt`,
  REVERSE_COMMON: `${BASEURL}/api/LeaseReverseReceipt/GetCommonData`,
  REVERSE_MULTI: `${BASEURL}/api/LeaseReverseReceipt/GetMultipleDropdown`,
  REVERSE_CASCAD: `${BASEURL}/api/LeaseReverseReceipt/GetCascadDropdown`,
  GET_PAYMENT_PLAN: `${BASEURL}/api/LeaseCommon/LeasePaymentPlan`,

  // Lease Revenue Posting
  GET_REVENUE_LIST: `${BASEURL}/api/LeaseRevenue/Get`,
  GET_REVENUE_MULTI: `${BASEURL}/api/LeaseRevenue/GetMultipleDropdown`,
  GET_REVENUE_CASCAD: `${BASEURL}/api/LeaseRevenue/GetCascadDropdown`,
  GET_REVENUE_COMMON: `${BASEURL}/api/LeaseRevenue/GetCommonData`,
  POST_REVENUE: `${BASEURL}/api/LeaseRevenue/PostLeaseRevenue`,
  // Lease General Invoice
  GET_GENERAL_LIST: `${BASEURL}/api/GeneralInvoice/Get`,
  GET_GENERAL_MULTI: `${BASEURL}/api/GeneralInvoice/GetLeaseGeneralInvoiceDdls`,
  GET_GENERAL_CASCAD: `${BASEURL}/api/GeneralInvoice/GetGeneralInvoiceCascadDdls`,
  GET_GENERAL_COMMON: `${BASEURL}/api/GeneralInvoice/GetGeneralInvoiceCommonData`,
  POST_GENERAL: `${BASEURL}/api/GeneralInvoice/Create`,
  // Lease Receipt

  RECEIPT_DROPDOWN: `${BASEURL}/api/LeaseReceipt/GetMultipleDropdown`,
  CASCAD_DROP: `${BASEURL}/api/LeaseReceipt/GetCascadDropdown`,
  LEASE_NO_DATA: `${BASEURL}/api/LeaseReceipt/GetCommonData`,
  CREATE_LEASE_RECEIPT: `${BASEURL}/api/LeaseReceipt/CreateReceipt`,
  GET_RECEIPT: `${BASEURL}/api/LeaseReceipt/Get`,
  // Inventory Update

  POST_INVENTORY: `${BASEURL}/api/LeaseAgreement/InventoryUpdate`,


  // Manage Payment
  POST_PAYMENT: `${BASEURL}/api/ManagePayment/Create`,
  PAYMENT_COMMON: `${BASEURL}/api/ManagePayment/GetManagePaymentCommonData`,
  PAYMENT_MULTI: `${BASEURL}/api/ManagePayment/GetManagePaymentDdls`,
  PAYMENT_CASCAD: `${BASEURL}/api/ManagePayment/GetManagePaymentCascadDdls`,

  // Reports
  REPORT_MULTI_DROP: `${BASEURL}/api/LeaseReports/GetMultipleDropdown`,
  REPORT_CASCAD: `${BASEURL}/api/LeaseReports/GetCascadDropdown`,
  REPORT_LEASE_UNIT: `${BASEURL}/api/LeaseReports/GetLeaseUnitsAvailability`,
  REPORT_LEASE_STATEMENT: `${BASEURL}/api/LeaseReports/GetLeaseStatement`,
  REPORT_TAX_STATEMENT: `${BASEURL}/api/LeaseReports/GetTaxStmtDetail`,
  REPORT_TENANT_INVOICE: `${BASEURL}/api/LeaseReports/GetTenantInvoiceReport`,
  REPORT_TENANT_OCCUPANCY: `${BASEURL}/api/LeaseReports/GetOccupancyReport`,
  REPORT_LEASE_OUTSTANDING: `${BASEURL}/api/LeaseReports/GetLeaseOutstanding`,
  REPORT_MONTH_WISE_REVENUE: `${BASEURL}/api/LeaseReports/GetMonthWiseRevenueReport`,
  REPORT_UNIT_MASTER_LIST: `${BASEURL}/api/LeaseReports/GetUnitMasterListReport`,
  REPORT_REVENUE_AGAINST_INVOICES: `${BASEURL}/api/LeaseReports/GetRevenueReportAgainstInvoices`,
  REPORT_AGING_ANALYSIS: `${BASEURL}/api/LeaseReports/AgingAnalysisLease`,
  REPORT_MOVE_IN_OUT: `${BASEURL}/api/LeaseReports/GetLeaseMoveInOut`,
  REPORT_LEASE_RECEIPTS: `${BASEURL}/api/LeaseReports/GetLeaseReceipts`,
  REPORT_PDC_LIST: `${BASEURL}/api/LeaseReports/GetPDCList`,
  REPORT_CHEQUE_LIST: `${BASEURL}/api/LeaseReports/GetChequeList`,
  REPORT_ACCRUED_RENT: `${BASEURL}/api/LeaseReports/GetAccruedRentReport`,
  // Agreement Attachment
  UPLOAD_FILE: `${BASEURL}/api/FileUpload/files`,
  GET_ATTACHMENT: `${BASEURL}api/LeaseAgreement/GetAttachmentsByLeaseNo`,
  UPLOAD_ATTACHMENT: `${BASEURL}/api/LeaseAgreement/CreateAttachments`,
  UPDATE_ATTACHMENT: `${BASEURL}/api/LeaseAgreement/UpdateAttachments`,
  DELETE_ATTACHMENT: `${BASEURL}/api/LeaseAgreement/DeleteAttachments/`, 


};
